'use client';

import { useRouter } from "next/navigation";
import { useLenis } from "lenis/react";
import { ROUTES } from "@/lib/routes";
import './textHeader.scss'

const TextHeader = () => {
  const router = useRouter();
  const lenis = useLenis();

  const goHome = () => {
    lenis?.scrollTo(0, { immediate: true });
    if (typeof window !== 'undefined') window.scrollTo(0, 0);
    router.push(ROUTES.home);
  };

  return (
    <div id='image-content-home' className={'image-content-home'} onClick={goHome}>
      <img 
        src="/assets/gif/TOL_512.webp" 
        alt="The Other Lab" 
        width={512}
        height={512}
        style={{ width: '100%', height: 'auto' }} 
      />
    </div>
  )
}

export default TextHeader;
